import React from 'react';
import { WebsiteDesignProps } from './types';
import { Palette, Brush, Sparkles } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ArtisticSoul: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Canvas Academy";

    return (
        <div className="bg-[#fffdf5] text-[#333] min-h-screen font-sans overflow-hidden">
             {/* Background blobs */}
             <div className="fixed top-[-100px] right-[-100px] w-96 h-96 bg-[#ffcdc2] rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse"></div>
             <div className="fixed top-[-100px] left-[-100px] w-96 h-96 bg-[#c2f0ff] rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse delay-700"></div>
             <div className="fixed bottom-[-100px] left-[20%] w-96 h-96 bg-[#fff6c2] rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse delay-1000"></div>

             <nav className="relative z-10 p-8 flex justify-between items-center">
                 <div className="font-serif italic text-2xl bg-white/50 px-4 py-2 rounded-full backdrop-blur-sm border border-black/5">
                     {schoolName} ⋆
                 </div>
                 <div className="hidden md:flex gap-6 font-medium text-sm">
                     <a href="#" className="hover:underline decoration-wavy decoration-pink-400">Portfolio</a>
                     <a href="#" className="hover:underline decoration-wavy decoration-blue-400">Workshops</a>
                     <a href="#" className="hover:underline decoration-wavy decoration-yellow-400">About</a>
                 </div>
                 <Button className="rounded-full bg-black text-white hover:bg-gray-800">Apply</Button>
             </nav>

             <main className="container mx-auto px-6 py-12 relative z-10 flex flex-col md:flex-row items-center gap-16">
                 <div className="flex-1">
                     <h1 className="text-6xl md:text-8xl font-serif leading-none mb-8 text-[#1a1a1a]">
                         Imagine. <br/>
                         <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-violet-500">Create.</span> <br/>
                         Inspire.
                     </h1>
                     <p className="text-xl font-light text-gray-600 mb-10 max-w-md">
                         A sanctuary for the creative spirit. We nurture the artists of tomorrow through freedom, expression, and mastery.
                     </p>
                     <div className="flex gap-4">
                         <div className="group relative">
                             <div className="absolute inset-0 bg-pink-400 rounded-full blur opacity-40 group-hover:opacity-60 transition-opacity"></div>
                             <Button className="relative bg-white text-black border border-black/10 rounded-full h-12 px-8 hover:bg-gray-50">Explore Courses</Button>
                         </div>
                     </div>
                 </div>
                 
                 <div className="flex-1 relative">
                      <div className="grid grid-cols-2 gap-4">
                          <img src="https://images.unsplash.com/photo-1513364776144-60967b0f800f?q=80&w=2071&auto=format&fit=crop" className="rounded-t-[50px] rounded-b-[10px] w-full h-64 object-cover transform translate-y-8" alt="Art 1" />
                          <img src="https://images.unsplash.com/photo-1547826039-bfc35e0f1ea8?q=80&w=1972&auto=format&fit=crop" className="rounded-t-[10px] rounded-b-[50px] w-full h-64 object-cover" alt="Art 2" />
                      </div>
                      <div className="absolute -z-10 bg-yellow-300 w-full h-full top-4 left-4 rounded-3xl opacity-50"></div>
                 </div>
             </main>
        </div>
    );
};

export default ArtisticSoul;
